<!-- RECEIPT -->
<div class="receipt" *ngIf="!isDone">

  <div class="row-main">

    <!-- LEFT COLUMN -->
    <div class="col left">

      <div class="line">
        <span><b>बुक सेलर :</b></span>
        <span>{{ sendmsgform.value.bsname }}</span>
      </div>

      <div class="line">
        <span><b>प्रतिनिधी :</b></span>
        <span>{{ sendmsgform.value.repname }}</span>
      </div>

      <div class="line split">
        <div class="split-item">
          <span><b>ऑर्डर नं :</b></span>
          <span>{{ sendmsgform.value.orderno }}</span>
        </div>
        <div class="split-item">
          <span><b>दिनांक :</b></span>
          <span>{{ sendmsgform.value.orderdate }}</span>
        </div>
      </div>

      <div class="line split">
        <div class="split-item">
          <span><b>बिल नं :</b></span>
          <span>{{ sendmsgform.value.billno }}</span>
        </div>
        <div class="split-item">
          <span><b>दिनांक :</b></span>
          <span>{{ sendmsgform.value.billdate }}</span>
        </div>
      </div>

      <div class="line split">
        <div class="split-item">
          <span><b>पावती नं :</b></span>
          <span>{{ sendmsgform.value.receiptno }}</span>
        </div>
        <div class="split-item">
          <span><b>दिनांक :</b></span>
          <span>{{ sendmsgform.value.receiptdate }}</span>
        </div>
      </div>

      <!-- BOOK HEADER -->
      <div class="book-header">
        <div><b>पुस्तक</b></div>
        <div><b>प्रती</b></div>
      </div>

      <!-- BOOK LIST -->
      <div *ngFor="let item of books; let i = index" class="book-row">
        <div class="book-name-col">{{ i + 1 }}) {{ item.bookname }}</div>
        <div class="book-copy-col">{{ item.bookcopies }}</div>
      </div>

      <!-- COURIER -->
   <div class="noPrint" style="margin: 10px 15px; display:flex; gap:10px; align-items:center;">
   <input
          class="courier-global-input"
          placeholder="Courier Name"
          [formControl]="courierNameCtrl"
          (ngModelChange)="saveCourierToStorage()" />

        <input
     class="courier-global-input"
          type="date"
          [formControl]="courierDateCtrl"
          (change)="saveCourierToStorage()" />
</div>

    </div>
    <!-- END LEFT COLUMN -->

    <!-- RIGHT COLUMN -->
    <div class="col right">

      <div class="delivery">{{ book?.deliverymode || 'By Hand' }}</div>

      <div class="line"><b>प्रति,</b></div>

      <div class="line">
        <span><b>बुक सेलर :</b></span>
        <span>{{ book?.custname }}</span>
      </div>

      <div class="line">
        <span><b>पत्ता :</b></span>
        <span>{{ sendmsgform.value.address2 }}</span>
      </div>

      <div class="line">
        <span><b>मोबाईल :</b></span>
        <span>{{ sendmsgform.value.mobno }}</span>
      </div>

      <!-- FOOTER -->
      <div style="display:flex; margin-top:20px;">
        <div style="width:40%;">
          <img src="../../../assets/img/brand/book.png" style="width:80%;" alt="logo">
        </div>
        <div style="width:60%; font-size:13px;">
          <b>प्रेषक,</b><br>
          हिंदुस्थान प्रकाशन संस्था - पुस्तक विभाग,<br>
            116-119,पहिला मजला, शिल्पीन सेंटर, 40, गं. द. आंबेकर मार्ग,,<br>
           वडाला मुंबई - 400031<br>
          दूरध्वनी: ९९६७५७०५३१
        </div>
      </div>

    </div>
    <!-- END RIGHT COLUMN -->

  </div>

</div>
<!-- END RECEIPT -->

<!-- DONE MESSAGE -->
<div class="done-msg" *ngIf="isDone">
  <span class="done-icon">✔</span>
  <span>Done! हे काम पूर्ण झाले आहे.</span>
</div>

<!-- BUTTONS -->
<div class="noPrint btns">
  <button class="btn-print" (click)="print()"       *ngIf="!isDone">Print</button>
  <button class="btn-done"  (click)="markAsDone()"  *ngIf="!isDone">✔ Done</button>
  <button class="btn-close" mat-dialog-close>Close</button>
</div>